module.exports = __webpack_public_path__ + "static/media/Add-task.f74e3a56.png";